var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorSpirit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.92 281.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-4,.cls-8{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-9{fill:#ffc99d;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-3,.cls-4,.cls-5,.cls-7,.cls-8,.cls-9{stroke:#2a3561;}.cls-13,.cls-15,.cls-16,.cls-18,.cls-3,.cls-4,.cls-9{stroke-linecap:round;}.cls-10,.cls-11,.cls-17,.cls-3,.cls-4,.cls-5,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-15,.cls-16,.cls-17,.cls-3,.cls-4,.cls-5,.cls-7,.cls-8{stroke-width:0.5px;}.cls-5,.cls-6{fill:#2a3561;}.cls-7{fill:#37a7f4;}.cls-9{stroke-miterlimit:10;stroke-width:0.5px;}.cls-10{fill:#2b5889;}.cls-11,.cls-12,.cls-13,.cls-14,.cls-18,.cls-19{fill:#fff;}.cls-12,.cls-13,.cls-15,.cls-16,.cls-18{stroke-linejoin:round;}.cls-14{stroke-miterlimit:10;stroke-width:0.5px;}.cls-16,.cls-17{fill:#ff8080;}.cls-18{stroke-width:0.5px;}.cls-19{stroke-miterlimit:10;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -75,
    width: 303.92,
    height: 357.95
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ELEMENTS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-3",
    d: "M85.22,179.45l-5.15-6.31s1.46-4.78-1.49-7.93c-5.5-5.9-7.6-7-8.92-6.23s.32,4.24,2.15,5.89c0,0,.66,2.64-1.65,1.82-1.65-.59-6.48-5.95-9.13-9a3.58,3.58,0,0,0-4.74-.6h0a3.76,3.76,0,0,0-4-1.52,7.58,7.58,0,0,0-5.13,6.47c0,2.81.32,10.43,2.31,14.06s15.21,9.42,18.85,10.41a9.79,9.79,0,0,1,5.37,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    className: "cls-4",
    d: "M71.79,164.87l1.86,1.81S71,173.31,71.29,177.1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    className: "cls-4",
    x1: 56.25,
    y1: 157.11,
    x2: 65.24,
    y2: 168.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-3",
    d: "M49.69,157.11a4.72,4.72,0,0,1,3.21,3.42l8.92,11.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-3",
    d: "M47.54,160.18s1.51,0,2.83,2.49l.55,1.78,2.48,8s3.91,1.83,5.74,2.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-5",
    d: "M168.6,54.45a16.07,16.07,0,0,1,5.8,7.35c1.44,4.61,4.12,13.54,6.22,22.87,3,13.47,6.26,26.46-1.47,34.19s-13.81,13.77-13.81,13.77H109.68s22.08-69.58,26.77-74.43A27.37,27.37,0,0,1,168.6,54.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    className: "cls-3",
    x: 144.26,
    y: 109.98,
    width: 19.36,
    height: 31.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-6",
    d: "M147.35,116.28s3.48,6.08,15.23,8.39l1-1.71v-7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-3",
    d: "M153.94,60c-21.44,0-19.38,13-19.38,13V99.35c0,4.6,2.42,9.71,7.89,14.1l.13.12a18.94,18.94,0,0,0,23.47-.13l.14-.11a18.39,18.39,0,0,0,7.11-14V73S175.36,60,153.94,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-3",
    d: "M173.36,80.3s4.1-2.41,5.5,2c1.82,5.82-5.5,10.77-5.5,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-3",
    d: "M134.51,80.3s-4.1-2.41-5.49,2c-1.83,5.82,5.49,10.77,5.49,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-7",
    d: "M166.44,127.41l10.1,2.43-13,78.07,5,12.63H134.86l.84-91.94,8.13-1.19,10.37,14.35Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    className: "cls-8",
    x1: 133.91,
    y1: 202.25,
    x2: 141.23,
    y2: 217.61
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    className: "cls-8",
    x1: 164.45,
    y1: 202.25,
    x2: 161.63,
    y2: 220.54
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    className: "cls-8",
    x1: 154.2,
    y1: 141.77,
    x2: 135.7,
    y2: 166.74
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "cls-3",
    x: 133.72,
    y: 281.39,
    width: 20.22,
    height: 156.92
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    className: "cls-9",
    x: 183.05,
    y: 276.48,
    width: 21.05,
    height: 162.23,
    transform: "translate(-74.97 52.26) rotate(-12.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-10",
    d: "M113.92,367H223.28L168.54,220.54H128.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-11",
    d: "M200.06,147.94,188.14,231.4l44.25,109.67s-8.74,10.6-26,4.77-18.28-30.47-18.28-30.47L163.51,207.91l13-78.07,24.6,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-11",
    d: "M184.57,132s5.24,2.84,5.59,8.31-5.59,13.61-5.59,13.61,4,7.06,3.66,11.83c-.28,3.71-15,27.11-21.62,37.38a1.18,1.18,0,0,1-2.16-.84l12.08-72.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    className: "cls-8",
    x1: 148.41,
    y1: 187.42,
    x2: 151.59,
    y2: 203.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-12",
    d: "M119.93,130.32a24.85,24.85,0,0,0-14.58,6.49,20.74,20.74,0,0,0-6.48,12.58c-.94,7.37-2,24.56-2.75,39.22L83.51,174,66.19,188.83l30.66,36.09a11.29,11.29,0,0,0,7.53,4c2,.17,14.79-6.55,16-8.37L102.89,347.44s31.3-3.18,31.3-30.73,1.49-188.1,1.49-188.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-11",
    d: "M127.41,129.33s-5.65,1.92-6.92,7.26S123.72,151,123.72,151s-5.15,6.28-5.61,11.05c-.35,3.69,10.25,29.26,15,40.5a1.19,1.19,0,0,0,1.54.65,1.21,1.21,0,0,0,.74-1.12l.31-73.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    className: "cls-8",
    x1: 120.39,
    y1: 220.55,
    x2: 109.47,
    y2: 160.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-6",
    d: "M136.27,61.17c-2.72,4.09-4.42,12.72-4.08,18.47h2.33a18.56,18.56,0,0,0,9.74-9.78,32.31,32.31,0,0,0,1.6-4.17c5.63,4.88,15.21,11.1,27.51,11.1h2.89s-3.32-15.73-7.55-19.29c-2.53-2.13-9.58-3.86-14.77-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-8",
    d: "M132.19,79.64h2.32a18.54,18.54,0,0,0,9.75-9.78,31.38,31.38,0,0,0,1.59-4.17c5.64,4.87,15.22,11.1,27.52,11.1h2.89"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    className: "cls-8",
    x1: 149.99,
    y1: 220.54,
    x2: 175.11,
    y2: 366.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-3",
    d: "M153.79,85.37l-4.33,12.71a2.71,2.71,0,0,0,2.57,3.58h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-13",
    d: "M149.31,106.66h7.92a4,4,0,0,1-7.92,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-11",
    d: "M140.38,126.33l-10.56,2.49s-4.38,1.32-4.38,7.22v23h2.88V135.47s.05-2.89,1.72-3.8l6.81-1.49,3-.53,2.79-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-6",
    d: "M125.45,153.34h2.88V157h-2.88v-3.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-11",
    d: "M169.18,126.33l8.7,2.49s4.38,1.32,4.38,7.22v23h-2.88V135.47s0-2.89-1.73-3.8l-6.8-1.49-3.35-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-11",
    d: "M179.38,156.73a5.87,5.87,0,0,0-6.26,5.44c0,.21,0,.43,0,.64v23h2.5V163.37a3.83,3.83,0,0,1,3.15-4.4,4.18,4.18,0,0,1,.61-.05v-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-11",
    d: "M182.27,156.73a5.86,5.86,0,0,1,6.25,5.44,4.56,4.56,0,0,1,0,.64v23H186V163.37a3.83,3.83,0,0,0-3.15-4.4,4.18,4.18,0,0,0-.61-.05v-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-7",
    d: "M184.28,181.25v4.59H182.8v7h4.33a3.09,3.09,0,0,0,3.1-3.09h0v-8.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-7",
    d: "M177.66,181.25v4.59h1.5v7h-4.35a3.09,3.09,0,0,1-3.09-3.09h0v-8.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "cls-7",
    cx: 126.6,
    cy: 162.59,
    r: 5.86
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    className: "cls-7",
    cx: 126.6,
    cy: 162.59,
    r: 3.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-3",
    d: "M225.23,179.45l5.16-6.31s-1.46-4.78,1.48-7.93c5.51-5.9,7.61-7,8.93-6.23s-.33,4.24-2.15,5.89c0,0-.67,2.64,1.65,1.82,1.64-.59,6.47-5.95,9.12-9a3.58,3.58,0,0,1,4.74-.6h0a3.76,3.76,0,0,1,4-1.52,7.58,7.58,0,0,1,5.13,6.47c0,2.81-.33,10.43-2.32,14.06s-15.21,9.42-18.84,10.41a9.76,9.76,0,0,0-5.37,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-4",
    d: "M238.65,164.87l-1.86,1.81s2.62,6.63,2.36,10.42"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    className: "cls-4",
    x1: 254.19,
    y1: 157.11,
    x2: 245.21,
    y2: 168.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-3",
    d: "M260.77,157.11a4.72,4.72,0,0,0-3.21,3.42l-8.93,11.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-3",
    d: "M262.91,160.18s-1.5,0-2.83,2.49l-.55,1.78-2.48,8s-3.91,1.83-5.74,2.92"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-11",
    d: "M201.13,136.29s11.44,7.79,8.38,41.68L208,198.53l17.9-22.46,17.9,16.75-28.62,34.54A12.38,12.38,0,0,1,204.85,232a10.7,10.7,0,0,1-6.89-3,31.59,31.59,0,0,1-7.83-11.37Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    className: "cls-8",
    x1: 208.12,
    y1: 196.79,
    x2: 207.23,
    y2: 211.39
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    className: "cls-14",
    x: 223.5,
    y: 83.34,
    width: 19.32,
    height: 4.44,
    transform: "translate(-10.49 37.41) rotate(-8.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-11",
    d: "M247.4,114.77l-18.78,3a3.15,3.15,0,0,1-3.63-2.62v0l-3.52-22.23a3.17,3.17,0,0,1,2.62-3.63h0l18.79-3a3.17,3.17,0,0,1,3.63,2.62v0L250,111.14A3.18,3.18,0,0,1,247.4,114.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-11",
    d: "M241.61,84.2l-16.93,2.7a3.56,3.56,0,0,1-4.08-3h0a3.57,3.57,0,0,1,3-4.08l16.94-2.69a3.56,3.56,0,0,1,4.07,3h0a3.55,3.55,0,0,1-2.94,4.06Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    className: "cls-15",
    x1: 222.47,
    y1: 80.03,
    x2: 222.96,
    y2: 83.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    className: "cls-15",
    x1: 224.83,
    y1: 79.66,
    x2: 225.32,
    y2: 82.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    className: "cls-15",
    x1: 227.19,
    y1: 79.28,
    x2: 227.68,
    y2: 82.37
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    className: "cls-15",
    x1: 229.56,
    y1: 78.92,
    x2: 230.05,
    y2: 81.99
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    className: "cls-15",
    x1: 231.92,
    y1: 78.54,
    x2: 232.41,
    y2: 81.63
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    className: "cls-15",
    x1: 234.29,
    y1: 78.16,
    x2: 234.77,
    y2: 81.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    className: "cls-15",
    x1: 236.65,
    y1: 77.78,
    x2: 237.14,
    y2: 80.88
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    className: "cls-15",
    x1: 239.01,
    y1: 77.41,
    x2: 239.5,
    y2: 80.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    className: "cls-15",
    x1: 241.38,
    y1: 77.04,
    x2: 241.87,
    y2: 80.12
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-16",
    d: "M242.22,109l-10.44,1.66a2.65,2.65,0,0,1-3-2.19h0L227.09,98a2.65,2.65,0,0,1,2.19-3h0l10.44-1.66a2.65,2.65,0,0,1,3,2.2L244.41,106A2.65,2.65,0,0,1,242.22,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-6",
    d: "M239.62,99.77l-2.17.34a.38.38,0,0,1-.44-.31l-.33-2.17a.38.38,0,0,0-.43-.31h0l-2.41.38a.37.37,0,0,0-.31.42v0l.34,2.16a.39.39,0,0,1-.32.44l-2.16.34a.38.38,0,0,0-.32.42v0l.37,2.4a.38.38,0,0,0,.43.32h0l2.17-.34a.38.38,0,0,1,.44.31l.34,2.16a.37.37,0,0,0,.42.32h0l2.4-.38a.37.37,0,0,0,.31-.42v0l-.34-2.16a.39.39,0,0,1,.32-.44l2.16-.34a.38.38,0,0,0,.32-.43h0l-.37-2.4A.42.42,0,0,0,239.62,99.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-13",
    d: "M220.1,47.47a7.33,7.33,0,1,0,10.26,10.46l.1-.1L235.3,53,224.94,42.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-16",
    d: "M240.14,37.8a7.31,7.31,0,0,0-10.34,0l0,0-4.84,4.84L235.3,53l4.84-4.84A7.33,7.33,0,0,0,240.14,37.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-17",
    d: "M238.09,54.13a4.51,4.51,0,0,0,6.38,6.38l3-3-6.37-6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-13",
    d: "M250.41,48.18a4.5,4.5,0,0,0-6.37,0h0l-3,3,6.37,6.38,3-3a4.49,4.49,0,0,0,0-6.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-13",
    d: "M81.85,34.57a4.51,4.51,0,1,0,6.38,6.37l3-3-6.38-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-7",
    d: "M94.17,28.62a4.5,4.5,0,0,0-6.37,0h0l-3,3L91.2,38l3-3A4.51,4.51,0,0,0,94.17,28.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-13",
    d: "M170.08,27.08a4.51,4.51,0,0,0,6.38,6.37l3-3-6.38-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-17",
    d: "M182.41,21.14a4.51,4.51,0,0,0-6.38,0h0l-3,3,6.38,6.37,3-3a4.5,4.5,0,0,0,0-6.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    className: "cls-17",
    cx: 219.99,
    cy: 34.78,
    r: 4.63
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    className: "cls-15",
    x1: 223.26,
    y1: 31.5,
    x2: 216.71,
    y2: 38.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    className: "cls-7",
    cx: 155.49,
    cy: 19.09,
    r: 6.48
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    className: "cls-15",
    x1: 150.91,
    y1: 14.51,
    x2: 160.06,
    y2: 23.68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-13",
    d: "M76.62,54.57A8.13,8.13,0,0,0,65.13,66.06l5.37,5.37L82,59.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-7",
    d: "M70.5,71.45s-1.07-3.08,2.67-7.78C77.57,58.14,82,60,82,60a14.93,14.93,0,0,1-3.54,8.58A8.42,8.42,0,0,1,70.5,71.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    className: "cls-17",
    cx: 77.77,
    cy: 63.65,
    r: 1.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    className: "cls-17",
    d: "M74.08,64.33a1.29,1.29,0,0,0-.58-1.07c-.11.14-.22.25-.33.4A14.61,14.61,0,0,0,72,65.32a1.27,1.27,0,0,0,2.08-1Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    className: "cls-17",
    cx: 76.17,
    cy: 70.44,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    className: "cls-17",
    cx: 81.84,
    cy: 69.15,
    r: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-7",
    d: "M87.31,84.28l-3.08-6.94a8.71,8.71,0,0,0-8.4-.12,12,12,0,0,0-6.46,6.72l3.08,6.94a8.13,8.13,0,0,0,14.86-6.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    className: "cls-17",
    cx: 118.92,
    cy: 24.89,
    r: 2.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-13",
    d: "M130.16,28.86l-16.64-4.93a2.19,2.19,0,0,0-2.72,1.47h0l-.52,1.76A2.28,2.28,0,0,0,111.82,30h0l1.22.36L103.08,64a4.16,4.16,0,0,0,2.79,5.16h0L112,71a4.14,4.14,0,0,0,5.15-2.8h0l10-33.68,1.22.36a2.25,2.25,0,0,0,2.81-1.53h0l.51-1.75A2.19,2.19,0,0,0,130.16,28.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    className: "cls-15",
    x1: 111.81,
    y1: 29.98,
    x2: 121.22,
    y2: 32.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-17",
    d: "M111.49,68l-3.38-1A3.11,3.11,0,0,1,106,63.14h0L110.5,48l9.33,2.76L115.35,65.9A3.08,3.08,0,0,1,111.51,68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    className: "cls-17",
    cx: 119.81,
    cy: 42.25,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    className: "cls-17",
    cx: 113.26,
    cy: 42.04,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    className: "cls-17",
    cx: 118.09,
    cy: 36.18,
    r: 1.41
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-13",
    d: "M213.89,68.08l-15.17-13L193.1,43.32l-7.53,3.59,5.62,11.77h0l.56,20a5.48,5.48,0,0,0,4.75,5.27,5.41,5.41,0,0,0,3.07-.49l6.57-3.13,6.56-3.13a5.47,5.47,0,0,0,2.58-7.29,5.32,5.32,0,0,0-1.39-1.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    className: "cls-18",
    x: 183.96,
    y: 44.99,
    width: 11.9,
    height: 2.74,
    transform: "translate(-1.44 86.38) rotate(-25.53)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    className: "cls-7",
    d: "M211.09,68.88,205,63.65l-5.45,2.6-5.44,2.6.25,8a4,4,0,0,0,4.07,3.82,4,4,0,0,0,1.57-.38l5.1-2.44,5.09-2.44A4,4,0,0,0,212.45,72,3.91,3.91,0,0,0,211.09,68.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-7",
    d: "M230.44,144.65l-2.13,1.6a1.33,1.33,0,0,0,2.21-1.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    className: "cls-11",
    d: "M226.17,137.43a35.77,35.77,0,0,1-2.95-6.41l-.1-.31a34.21,34.21,0,0,0-4.94-9.3L202,99.88l-8.78,6.6L209.4,128a34.36,34.36,0,0,0,7.56,7.33h0a38.77,38.77,0,0,1,5.82,5l5.53,5.87,1.07-.8,1.07-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    className: "cls-7",
    d: "M196.5,99.09,194,101a3.92,3.92,0,0,0-.79,5.48h0l8.78-6.6A3.92,3.92,0,0,0,196.5,99.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    className: "cls-7",
    d: "M209.6,123.6l-6.53-8.69a2.69,2.69,0,0,1,.53-3.76h0a2.69,2.69,0,0,1,3.76.53l6.53,8.69a2.69,2.69,0,0,1-.53,3.76h0a2.68,2.68,0,0,1-3.76-.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    className: "cls-7",
    cx: 200.65,
    cy: 107.26,
    r: 2.68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    className: "cls-11",
    d: "M81.33,144.62l-4.77-2.19a2.45,2.45,0,0,1-1.2-3.26L90,107.31a2.47,2.47,0,0,1,3.26-1.21L98,108.3a2.45,2.45,0,0,1,1.21,3.26L84.58,143.42A2.44,2.44,0,0,1,81.33,144.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    className: "cls-16",
    d: "M88.81,122.48l-.33-.15a2.19,2.19,0,0,1-1.08-2.9l3.6-7.82a2.19,2.19,0,0,1,2.9-1.08l.33.15a2.19,2.19,0,0,1,1.08,2.9l-3.6,7.82a2.18,2.18,0,0,1-2.89,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    className: "cls-7",
    d: "M91.5,131.71l-11.76-5.4A1.72,1.72,0,0,1,78.9,124h0a1.72,1.72,0,0,1,2.27-.84l11.76,5.4a1.72,1.72,0,0,1,.84,2.28h0A1.72,1.72,0,0,1,91.5,131.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    className: "cls-7",
    d: "M84.18,147.62l-11.76-5.41a1.71,1.71,0,0,1-.84-2.27h0a1.72,1.72,0,0,1,2.27-.85l11.76,5.41a1.72,1.72,0,0,1,.85,2.27h0a1.71,1.71,0,0,1-2.25.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    className: "cls-19",
    x: 93.11,
    y: 101.27,
    width: 8.63,
    height: 4.06,
    transform: "translate(-37.11 148.7) rotate(-65.32)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    className: "cls-8",
    x1: 103.78,
    y1: 89.46,
    x2: 99.23,
    y2: 99.37
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    className: "cls-8",
    x1: 83.87,
    y1: 131.07,
    x2: 89.15,
    y2: 133.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    className: "cls-8",
    x1: 82.56,
    y1: 133.92,
    x2: 87.83,
    y2: 136.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    className: "cls-8",
    x1: 81.24,
    y1: 136.78,
    x2: 86.52,
    y2: 139.19
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    className: "cls-8",
    x1: 79.93,
    y1: 139.63,
    x2: 85.21,
    y2: 142.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    className: "cls-11",
    d: "M55.71,92.63l-5.93-.79-5.92-.79-9.52,13.11a5.06,5.06,0,0,0-.93,2.32l-3.49,26.15a5.07,5.07,0,0,0,4.35,5.69h0l18.28,2.44a5.05,5.05,0,0,0,5.69-4.34v0l3.49-26.17a5.11,5.11,0,0,0-.29-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    className: "cls-11",
    d: "M55.73,92.63l-11.9-1.58a3.24,3.24,0,0,1-2.78-3.62l.29-2.15A3.24,3.24,0,0,1,45,82.5l11.9,1.58a3.25,3.25,0,0,1,2.78,3.62l-.29,2.15a3.21,3.21,0,0,1-3.61,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    className: "cls-17",
    d: "M54.43,135.24,33.91,132.5a1.83,1.83,0,0,1-1.58-2.07h0l2.73-20.52a1.85,1.85,0,0,1,2.07-1.59h0l20.52,2.73a1.84,1.84,0,0,1,1.58,2.07h0l-2.72,20.52A1.86,1.86,0,0,1,54.43,135.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    className: "cls-6",
    d: "M51.09,120.18,49,119.9a.61.61,0,0,1-.53-.68h0l.28-2.11a.61.61,0,0,0-.52-.69h0L44.87,116a.62.62,0,0,0-.69.52h0l-.28,2.11a.6.6,0,0,1-.68.53h0l-2.12-.28a.61.61,0,0,0-.69.52h0L40,122.71a.61.61,0,0,0,.52.69h0l2.11.28a.62.62,0,0,1,.53.68h0l-.28,2.11a.6.6,0,0,0,.52.69h0l3.32.45a.62.62,0,0,0,.69-.52h0l.28-2.12a.62.62,0,0,1,.68-.53h0l2.11.27a.6.6,0,0,0,.69-.52h0l.45-3.32a.61.61,0,0,0-.51-.69Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    className: "cls-8",
    x1: 44.36,
    y1: 82.42,
    x2: 43.86,
    y2: 86.18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    className: "cls-8",
    x1: 46.7,
    y1: 82.72,
    x2: 46.19,
    y2: 86.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    className: "cls-8",
    x1: 49.02,
    y1: 83.04,
    x2: 48.52,
    y2: 86.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    className: "cls-8",
    x1: 51.36,
    y1: 83.35,
    x2: 50.86,
    y2: 87.11
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    className: "cls-8",
    x1: 53.69,
    y1: 83.65,
    x2: 53.19,
    y2: 87.43
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    className: "cls-4",
    x1: 96.12,
    y1: 188.59,
    x2: 110.87,
    y2: 205.8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorSpirit);
export default __webpack_public_path__ + "static/media/doctorSpirit.fc8dc7a9555b112a78324ec1ac697c51.svg";
export { ForwardRef as ReactComponent };